export default __webpack_public_path__ + "static/media/refresh-white.7072f44b.svg";